import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=c9799700&"
var script = {}
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules_dev/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports